import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "main-container" }
const _hoisted_2 = { class: "filter-container" }
const _hoisted_3 = { class: "action-list" }
const _hoisted_4 = { ref: "innerRef" }
const _hoisted_5 = ["innerHTML"]

import { useRoute, useRouter } from 'vue-router'
import { getCurrentInstance, ref, reactive, onMounted, onActivated, watch } from 'vue'
import Pagination from '@/components/Pagination.vue'
import { getVenderListApi, getProductListApi, delProductApi, saveProductApi, updateProductStatusApi } from '@/apis/couponline'
import { getChannelList } from '@/apis/channel'
import { ChannelM } from '@/models/channel'
import Keys from '@/constant/key'
import { joinParams } from '@/utils/index'

// 列表行对象格式
interface rowI {
    id?: string, // 记录ID
    mid: string, // 渠道ID
    venderid: number | string, // 厂家ID
    name: string, // 商品名称
    type: string | undefined, // 商品SKU
    servicetype: number, // 类型
    purchaseprice: string, // 厂家结算价
    retailprice: string, // 建议零售价
    price: string, // 渠道结算价
    flag: string, // 状态
}
// 厂家对象格式
interface venderI {
    id: number,
    name: string
}
// 商品对象格式
interface couponI {
    id: number,
    name: string,
    type: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ProductList',
  setup(__props) {

const { proxy } = getCurrentInstance() as any
const route = useRoute() as any
const router = useRouter() as any

const filters = reactive({
    mid: '', // 渠道id
    venderid: '', // 厂家ID
    name: '', // 电子券名称
    flag: '', // 状态
    servicetype: '', // 电子券类型
    if_mr_channel: 0, // 是否包含默认渠道
    page: 1,
    page_size: 10,
})
    const scrollerHeight = ref<number>(400)
    const state = reactive ({
        dialogVisibleNew: false,
        dialogVisibleError:false,//错误提示弹框
        error:'',//上传错误信息显示
    })
    //打开商品批量上传弹窗
    const openDialogNew = () => {
        state.dialogVisibleNew = true
        
    }
    const uploadRef = ref()
    // 关闭商品批量上传弹框
    const dialogBeforeCloseNew = () => {
        //清除数据
        uploadRef.value!.clearFiles()
        state.dialogVisibleNew = false
        getList()
    }
    const formatError = (error) => {
      return error.replace(/!!!/g, '<br>');
    }
    //打开错误弹窗
    const dialogVisibleError = () => {
        state.dialogVisibleError = true
    }
    //关闭错误弹窗
    const dialogBeforeCloseError = () =>{
        uploadRef.value!.clearFiles()
        state.dialogVisibleNew = false
        state.dialogVisibleError = false
        getList()
    }
    //点击确认关闭错误弹窗
    const dialogSure = () =>{
        uploadRef.value!.clearFiles()
        state.dialogVisibleError = false
        state.dialogVisibleNew = false
        getList()
    }
    const onUploadSuccess= async (res) => {
        const { code, data, msg } = res
        if(code == 200) {
            proxy.$message({ type: 'success', message: msg })
            dialogBeforeCloseNew()
            getList()
        } else if (code == 209) {
            const array = Object.values(data);
            let formattedStr = array.map(item => item.msg + "!!!").join("\n");
            state.error = formattedStr
            dialogVisibleError()
            return proxy.$message({ type: 'error', message: msg})
        }else {
            return proxy.$message({ type: 'error', message: msg })
        }
    }
    //确定上传
    const dialogSubmit= () => {
        proxy.$refs.uploadRef.submit()
    }
// 获取所有渠道并添加“默认渠道”
const channelList = ref<ChannelM[]>([])
const onGetChannelList = async () => {
    const {code, data, msg} = await getChannelList() as any
    if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
    // 添加默认渠道
    data.push({
        id: 0,
        channel_no: 'default',
        channel_name: '默认渠道'
    })
    channelList.value = data
}

// 初始化列表数据
const total = ref()
const tableData = ref<rowI[]>([])
const getList = async () => {
    const { code, data, msg } = await getProductListApi(filters) as any
    if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
    tableData.value = data.data
    total.value = data.total
}
// 表格 index 连续
const tableIndex = (index) => {
    return (filters.page - 1) * filters.page + index + 1
}
const onSearch = () => {
    filters.page = 1
    getList()
}
const out = (type) => {
    window.open(`${Keys.baseUrl}/couponrecharge/coupon_api/vender_sku_list?${joinParams({...filters})}&type=${type}`)
}
const channel_name = ref('')
const onChannelChange = (val) => {
    const selected = channelList.value.find((item:ChannelM) => item.id == val) as any
    filters.mid = val
    channel_name.value = selected.channel_name
    // getList()
}
const onPageChange = (val) => {
    filters.page = val
    getList()
}
const onSizeChange = (val) => {
    filters.page_size = val
    getList()
}
// 编辑
const onEdit = (row) => {
    Object.assign(formData, {...row})
    previewList.value = [row.image]
    productDialog.value = true
}
// 删除
const onDel = (row) => {
    proxy.$confirm(`确定要删除 ${ row.title } 吗？`, '提示', {
        type: 'warning'
    }).then(() => {
       delProductApi(row.id).then((res:any) => {
            const { code, data, msg } = res
            if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
            proxy.$message({ type: 'error', message: '删除成功' })
            getList()
       })
    }).catch(() => {
        console.log('')
    })
}
// 上下架
const onUpdateStatus = (row) => {
    const { id, flag, name } = row
    proxy.$confirm(`确定要${ flag == 0 ? '上架': '下架' } ${ name } 吗？`, '提示', {
        type: 'warning'
    }).then(() => {
        updateProductStatusApi(id, flag ^ 1, filters.mid).then((res:any) => {
            const { code, data, msg } = res

            if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
            proxy.$message({ type: 'success', message: '保存成功' })
            getList()
       })
    }).catch(() => {
        console.log('取消状态更改')
    })
}
/** 选择商品弹框逻辑 -- begin */ 
const productDialog = ref(false) // 弹框
const venderProductList = ref<couponI[]>([]) // 不同厂家下的电子券列表
const formData = reactive<rowI>({
    id: '', // 记录ID
    mid: '', // 渠道ID
    venderid: '', // 厂家ID
    name: '', // 商品名称
    type: '', // 商品SKU
    servicetype: 0, // 类型
    purchaseprice: '', // 厂家结算价
    retailprice: '', // 建议零售价
    price: '', // 渠道结算价
    flag: '', // 状态
})
const openDialog = () => {
    productDialog.value = true
    proxy.$refs.productForm?.clearValidate()
}
// 厂家变化重新获取商品列表
const onVenderChange = async (val) => {
    if (!filters.mid) return
    const { code, data, msg } = await getProductListApi({ venderid: val, flag: 1, page: 1, page_size: 10000 }) as any
    if (code != 200) return proxy.$message({ type: 'error', message: msg })
    
    // // 清空表单内除厂家外的其他数据
    proxy.$refs.productForm.resetFields()
    formData.venderid = val

    venderProductList.value = data.data
}
// 商品变化 sku、厂家结算价、建议零售价 重新赋值
const onProductChange = (val) => {
    const selectedItem = venderProductList.value.find((item:couponI) => item.id === val)
    const { type, purchaseprice, retailprice, servicetype } = selectedItem as any
    formData.servicetype = servicetype
    formData.type = type
    formData.purchaseprice = purchaseprice
    formData.retailprice = retailprice
}
const previewList = ref<any[]>([])
// 保存
const onSubmit = () => {
    proxy.$refs.productForm.validate((valid) => {
        if (valid) {
            //@ts-ignore
            const selectedItem = venderProductList.value.find((item:couponI) => item.id === formData.name)
            if (selectedItem) {
                const { name } = selectedItem as any
                formData.name = name
            }
            formData.mid = filters.mid
            saveProductApi(formData).then((res:any) => {
                const { code, data, msg } = res
                if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
                proxy.$message({ type: 'success', message: '保存成功' })
                beforeProductDialogClose()
                getList()
            })
        }
    })
}
// 关闭弹框前清空数据
const beforeProductDialogClose = () => {
    productDialog.value = false
    Object.assign(formData, {
        id: '', // 记录ID
        mid: '', // 渠道ID
        venderid: '', // 厂家ID
        name: '', // 商品名称
        type: '', // 商品SKU
        servicetype: 0, // 类型
        purchaseprice: '', // 厂家结算价
        retailprice: '', // 建议零售价
        price: '', // 渠道结算价
        flag: '', // 状态
    })
}
// 校验：渠道结算价须大于等于厂家结算价
const checkPrice = (rule:any, val:any, callback:any) => {
    const { purchaseprice } = formData
    if (val && purchaseprice && Number(val) < Number(purchaseprice)) {
        callback(new Error('渠道结算价 须大于等于 厂家结算价'))
    } else {
        callback()
    }
}
const rules = reactive({
    venderid: [
        { required: true, message: '请选择厂家', trigger: 'change' }
    ],
    type: [
        { required: true, message: '请填写SKU', trigger: 'blur' }
    ],
    name: [
        { required: true, message: '请填写电子券名称', trigger: 'blur' }
    ],
    servicetype: [
        { required: true, message: '请选择类型', trigger: 'change' }
    ],
    purchaseprice: [
        { required: true, message: '请填写厂家结算价', trigger: 'blur' }
    ],
    retailprice: [
        { required: true, message: '请填写建议零售价', trigger: 'blur' }
    ],
    price: [
        { required: true, message: '请填写渠道结算价', trigger: 'blur' },
        { validator: checkPrice, trigger: 'blur' }
    ],
    flag: [
        { required: true, message: '请选择状态', trigger: 'change' }
    ]
})
/** 添加商品弹框逻辑 -- end */ 


// 获取厂家列表
const venderList = ref<venderI[]>([])
const getVenderList = async () => {
    const { code, data, msg } = await getVenderListApi() as any
    if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
    venderList.value = data
}

onMounted(() => {
    if(route.path == '/couponline/product-list-channel'){
        filters.mid = '0'
        channel_name.value = '默认渠道'
    }
    // filters.mid = route.query.channel_id
    // channel_name.value = route.query.channel_name
    onGetChannelList()
})

onActivated(() => {
    getList()
    getVenderList()
})
// 监听路由变化，重新获取商品数据（自动获取下一条审核记录）
// watch(() => route.query.channel_id, (newVal, oldVal) => {
//     location.reload()
// })

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (filters.mid)
        ? (_openBlock(), _createBlock(_component_el_select, {
            key: 0,
            class: "filter-item",
            modelValue: filters.mid,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((filters.mid) = $event)),
            filterable: "",
            placeholder: "请选择渠道",
            onChange: onChannelChange
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(channelList.value, (item) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  key: item.id,
                  label: item.channel_name,
                  value: item.id + ''
                }, null, 8, ["label", "value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"]))
        : _createCommentVNode("", true),
      _createVNode(_component_el_input, {
        class: "filter-item",
        modelValue: filters.name,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filters.name) = $event)),
        modelModifiers: { trim: true },
        placeholder: "电子券名称",
        clearable: ""
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_select, {
        class: "filter-item",
        modelValue: filters.venderid,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((filters.venderid) = $event)),
        filterable: "",
        placeholder: "厂家",
        clearable: ""
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(venderList.value, (item) => {
            return (_openBlock(), _createBlock(_component_el_option, {
              key: item.id,
              label: item.name,
              value: item.id
            }, null, 8, ["label", "value"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["modelValue"]),
      (filters.mid)
        ? (_openBlock(), _createBlock(_component_el_select, {
            key: 1,
            class: "filter-item",
            modelValue: filters.flag,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((filters.flag) = $event)),
            filterable: "",
            placeholder: "状态",
            clearable: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_option, {
                label: "上架",
                value: 1
              }),
              _createVNode(_component_el_option, {
                label: "下架",
                value: 0
              })
            ]),
            _: 1
          }, 8, ["modelValue"]))
        : _createCommentVNode("", true),
      _createVNode(_component_el_select, {
        class: "filter-item",
        modelValue: filters.servicetype,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((filters.servicetype) = $event)),
        filterable: "",
        placeholder: "类型",
        clearable: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_option, {
            label: "直充",
            value: 0
          }),
          _createVNode(_component_el_option, {
            label: "卡券",
            value: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_button, {
        class: "filter-btn",
        type: "primary",
        onClick: _cache[5] || (_cache[5] = ($event: any) => (onSearch()))
      }, {
        default: _withCtx(() => _cache[24] || (_cache[24] = [
          _createTextVNode("搜索")
        ])),
        _: 1
      }),
      _createVNode(_component_el_button, {
        class: "filter-btn",
        type: "primary",
        onClick: _cache[6] || (_cache[6] = ($event: any) => (out(2)))
      }, {
        default: _withCtx(() => _cache[25] || (_cache[25] = [
          _createTextVNode("导出")
        ])),
        _: 1
      }),
      (filters.mid)
        ? (_openBlock(), _createBlock(_component_el_button, {
            key: 2,
            class: "filter-btn",
            type: "primary",
            onClick: openDialog
          }, {
            default: _withCtx(() => _cache[26] || (_cache[26] = [
              _createTextVNode("选择商品")
            ])),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_el_button, {
        class: "filter-btn",
        type: "primary",
        onClick: _cache[7] || (_cache[7] = ($event: any) => (_unref(router).push('/couponline/product-edit')))
      }, {
        default: _withCtx(() => _cache[27] || (_cache[27] = [
          _createTextVNode("添加厂家商品")
        ])),
        _: 1
      }),
      _createVNode(_component_el_button, {
        class: "filter-btn",
        type: "primary",
        onClick: openDialogNew
      }, {
        default: _withCtx(() => _cache[28] || (_cache[28] = [
          _createTextVNode("商品批量上传")
        ])),
        _: 1
      }),
      (filters.mid)
        ? (_openBlock(), _createBlock(_component_el_checkbox, {
            key: 3,
            modelValue: filters.if_mr_channel,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((filters.if_mr_channel) = $event)),
            "true-value": "1",
            "false-value": "0",
            label: "包含默认渠道",
            size: "large"
          }, null, 8, ["modelValue"]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_el_table, {
      data: tableData.value,
      border: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          type: "index",
          index: tableIndex
        }),
        _createVNode(_component_el_table_column, {
          prop: "name",
          label: "名称"
        }),
        _createVNode(_component_el_table_column, {
          prop: "vender_name",
          label: "厂家"
        }),
        _createVNode(_component_el_table_column, { label: "状态" }, {
          default: _withCtx((scope) => [
            _createTextVNode(_toDisplayString(scope.row.flag == 0 ? '下架' : '上架'), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "type",
          label: "类型"
        }, {
          default: _withCtx((scope) => [
            _createTextVNode(_toDisplayString(scope.row.servicetype == 0 ? '直充' : '卡券'), 1)
          ]),
          _: 1
        }),
        (!filters.mid)
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 0,
              prop: "purchaseprice",
              label: "厂家结算价"
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_el_table_column, {
          prop: "retailprice",
          label: "建议零售价"
        }),
        _createVNode(_component_el_table_column, {
          prop: "price",
          label: "渠道结算价"
        }),
        _createVNode(_component_el_table_column, {
          prop: "updatetime",
          label: "更新时间",
          width: "160"
        }),
        _createVNode(_component_el_table_column, {
          label: "操作",
          width: "130"
        }, {
          default: _withCtx((scope) => [
            _createElementVNode("div", _hoisted_3, [
              (filters.if_mr_channel == 0)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    (filters.mid)
                      ? (_openBlock(), _createBlock(_component_el_button, {
                          key: 0,
                          type: "primary",
                          size: "small",
                          onClick: ($event: any) => (onEdit(scope.row))
                        }, {
                          default: _withCtx(() => _cache[29] || (_cache[29] = [
                            _createTextVNode("编辑")
                          ])),
                          _: 2
                        }, 1032, ["onClick"]))
                      : (_openBlock(), _createBlock(_component_el_button, {
                          key: 1,
                          type: "primary",
                          size: "small",
                          onClick: ($event: any) => (_unref(router).push(`/couponline/product-edit?id=${scope.row.id}`))
                        }, {
                          default: _withCtx(() => _cache[30] || (_cache[30] = [
                            _createTextVNode("编辑")
                          ])),
                          _: 2
                        }, 1032, ["onClick"]))
                  ], 64))
                : _createCommentVNode("", true),
              _createVNode(_component_el_button, {
                type: "primary",
                size: "small",
                onClick: ($event: any) => (onUpdateStatus(scope.row))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(scope.row.flag == 0 ? '上架' : '下架'), 1)
                ]),
                _: 2
              }, 1032, ["onClick"])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"]),
    _createVNode(Pagination, {
      currentPage: filters.page,
      total: total.value,
      onPageChange: onPageChange,
      onSizeChange: onSizeChange
    }, null, 8, ["currentPage", "total"]),
    _createVNode(_component_el_dialog, {
      title: "商品编辑",
      modelValue: productDialog.value,
      "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((productDialog).value = $event)),
      "before-close": beforeProductDialogClose,
      style: {"width":"80%"}
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", null, [
          _createVNode(_component_el_button, { onClick: beforeProductDialogClose }, {
            default: _withCtx(() => _cache[36] || (_cache[36] = [
              _createTextVNode("取消")
            ])),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: onSubmit
          }, {
            default: _withCtx(() => _cache[37] || (_cache[37] = [
              _createTextVNode("保存")
            ])),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: formData,
          ref: "productForm",
          rules: rules,
          "label-width": "100",
          inline: true
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "渠道" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: channel_name.value,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((channel_name).value = $event)),
                  modelModifiers: { trim: true },
                  disabled: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "厂家",
              prop: "venderid"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: formData.venderid,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((formData.venderid) = $event)),
                  filterable: "",
                  placeholder: "厂家",
                  onChange: onVenderChange,
                  disabled: Boolean(formData.id),
                  clearable: ""
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(venderList.value, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.id,
                        label: item.name,
                        value: item.id
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "disabled"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "电子券名称",
              prop: "name"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: formData.name,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((formData.name) = $event)),
                  filterable: "",
                  placeholder: "请选择电子券",
                  disabled: Boolean(formData.id),
                  clearable: "",
                  onChange: onProductChange
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(venderProductList.value, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.id,
                        label: item.name,
                        value: item.id
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "disabled"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "SKU",
              prop: "type"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: formData.type,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((formData.type) = $event)),
                  modelModifiers: { trim: true },
                  placeholder: "请填写SKU",
                  clearable: "",
                  maxlength: "8",
                  disabled: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "类型",
              prop: "servicetype"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: formData.servicetype,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((formData.servicetype) = $event)),
                  filterable: "",
                  placeholder: "请选择类型",
                  clearable: "",
                  disabled: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      label: "直充",
                      value: 0
                    }),
                    _createVNode(_component_el_option, {
                      label: "卡券",
                      value: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "厂家结算价",
              prop: "purchaseprice"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  class: "has-append",
                  modelValue: formData.purchaseprice,
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((formData.purchaseprice) = $event)),
                  modelModifiers: { trim: true },
                  onInput: _cache[15] || (_cache[15] = ($event: any) => (formData.purchaseprice = formData.purchaseprice.replace(/[^0-9.]/g,''))),
                  placeholder: "请填写厂家结算价",
                  clearable: "",
                  disabled: ""
                }, {
                  append: _withCtx(() => _cache[31] || (_cache[31] = [
                    _createTextVNode("元")
                  ])),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "建议零售价",
              prop: "retailprice"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  class: "has-append",
                  modelValue: formData.retailprice,
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((formData.retailprice) = $event)),
                  modelModifiers: { trim: true },
                  onInput: _cache[17] || (_cache[17] = ($event: any) => (formData.retailprice = formData.retailprice.replace(/[^0-9.]/g,''))),
                  placeholder: "请填写建议零售价",
                  clearable: "",
                  disabled: ""
                }, {
                  append: _withCtx(() => _cache[32] || (_cache[32] = [
                    _createTextVNode("元")
                  ])),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            (filters.mid)
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 0,
                  label: "渠道结算价",
                  prop: "price"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      class: "has-append",
                      modelValue: formData.price,
                      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((formData.price) = $event)),
                      modelModifiers: { trim: true },
                      onInput: _cache[19] || (_cache[19] = ($event: any) => (formData.price = formData.price.replace(/[^0-9.]/g,''))),
                      placeholder: "请填写渠道结算价",
                      clearable: ""
                    }, {
                      append: _withCtx(() => _cache[33] || (_cache[33] = [
                        _createTextVNode("元")
                      ])),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_el_form_item, {
              label: "状态",
              prop: "flag"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio_group, {
                  modelValue: formData.flag,
                  "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((formData.flag) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_radio, { label: 1 }, {
                      default: _withCtx(() => _cache[34] || (_cache[34] = [
                        _createTextVNode("上架")
                      ])),
                      _: 1
                    }),
                    _createVNode(_component_el_radio, { label: 0 }, {
                      default: _withCtx(() => _cache[35] || (_cache[35] = [
                        _createTextVNode("下架")
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "商品批量上传",
      modelValue: state.dialogVisibleNew,
      "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((state.dialogVisibleNew) = $event)),
      "before-close": dialogBeforeCloseNew
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, { onClick: dialogBeforeCloseNew }, {
          default: _withCtx(() => _cache[39] || (_cache[39] = [
            _createTextVNode("取 消")
          ])),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: dialogSubmit
        }, {
          default: _withCtx(() => _cache[40] || (_cache[40] = [
            _createTextVNode("确 定")
          ])),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          ref: "inForm",
          "label-width": "120px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_upload, {
                  class: "upload-demo",
                  ref_key: "uploadRef",
                  ref: uploadRef,
                  action: `/api/couponrecharge/coupon_api/batch_update`,
                  "on-success": onUploadSuccess,
                  accept: ".xls,.xlsx",
                  "auto-upload": false
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      type: "primary",
                      size: "small"
                    }, {
                      default: _withCtx(() => _cache[38] || (_cache[38] = [
                        _createTextVNode("点击上传")
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 512)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 512)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "错误信息详情",
      modelValue: state.dialogVisibleError,
      "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((state.dialogVisibleError) = $event)),
      "before-close": dialogBeforeCloseError
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, { onClick: dialogBeforeCloseError }, {
          default: _withCtx(() => _cache[41] || (_cache[41] = [
            _createTextVNode("取 消")
          ])),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: dialogSure
        }, {
          default: _withCtx(() => _cache[42] || (_cache[42] = [
            _createTextVNode("确 定")
          ])),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_scrollbar, { height: scrollerHeight.value }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", {
                innerHTML: formatError(state.error),
                style: {"color":"red"}
              }, null, 8, _hoisted_5)
            ], 512)
          ]),
          _: 1
        }, 8, ["height"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})